import { Injectable } from '@angular/core';
import { OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { BaseDateTimeService } from '@shared/utils/date-time';
import { TimezoneSimplePipe } from '@shared/utils/time-zones';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DateTimeService extends BaseDateTimeService {
  constructor(private officerDetailsFacade: OfficerDetailFacade, private timezoneSimplePipe: TimezoneSimplePipe) {
    super();
  }

  override useMilitaryTime(): Observable<boolean> {
    return this.officerDetailsFacade.getLoggedInOfficer().pipe(map((officer) => officer.useMilitaryTime));
  }

  override formatDateTime(date: Date | null | undefined): Observable<string> {
    return this.officerDetailsFacade.getLoggedInOfficer().pipe(map((officer) => this.timezoneSimplePipe.transform(date, officer.timezone, officer.useMilitaryTime, true)));
  }

  override formatDate(date: Date | null | undefined): Observable<string> {
    return this.officerDetailsFacade.getLoggedInOfficer().pipe(map((officer) => this.timezoneSimplePipe.transform(date, officer.timezone, officer.useMilitaryTime, false)));
  }
}
